(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const h = 'is-hidden';
	const filterHidden = 'is-filter-hidden';
	// vanillaMatchHeight---------------------
	const vanillaMatchHeight = () => {
		const $elements = document.querySelectorAll('[data-vanillaMh]');
		const groups = new Map();

		$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

		$elements.forEach(ele => {
			const attributeName = ele.getAttribute('data-vanillaMh');
			const topPosition = ele.getBoundingClientRect().top;

			const key = attributeName + '_' + topPosition;
			if (!groups.has(key)) {
				groups.set(key, []);
			}
			groups.get(key).push(ele);
		});
		groups.forEach(group => {
			const maxHeight = Math.max(...group.map(ele => ele.offsetHeight));
			group.forEach(ele => {
				ele.style.height = `${maxHeight}px`;
			});
		});
	};
	window.addEventListener('resize', () => { vanillaMatchHeight() });
	const filesList = () => {
		// json出力部分 ------------------------
		if(document.querySelectorAll('.js-fileslist-json').length) {
			// 変数定義---------------------
			const serchBtn = document.querySelectorAll('.js-fileslist-json-searchKeyword button');
			const serchInput = document.querySelectorAll('.js-fileslist-json-searchKeyword input');
			const navInput = document.querySelectorAll('.js-fileslist-json-nav-button');
			const moreBtn = document.querySelectorAll('.js-fileslist-json-more');
			const loaderArea = document.querySelector('#js-loader');
			// json定義---------------------
			const getJSONfiles = () => {
				if(!(document.querySelectorAll('.js-fileslist-json_download').length == 0)) {
					return `/ajax/doc/service_career_doc.json`;
				} else if(!(document.querySelectorAll('.js-fileslist-json_research').length == 0)) {
					return `/ajax/doc/survey_data_doc.json`;
				} else {
					return `/ajax/doc/useful_materials_doc.json`;
				}
			};
			// html出力---------------------
			const addHTML = (_list) => {
				// console.log(_list,'json');
				let HTML = '';
				_list.forEach(function(val, index){
					let _bookmarkBtn = '<button type="button" class="mod-bookmark js-bookmark-btn" id="'+val._key+'"><svg class=""><use xlink:href="/common/svg/sprite.svg#bookmark" /></svg></button>';
					// console.log(val, index);
					// タグ部分
					let _tag = '';
					let _btn = '<span class="di_none js-bookmark-category">7</span><a href="'+val.rt_cf_d_href.href+'" class="__button mt20 js-sessionstrage-url js-bookmark-url"><span>詳細ページへ<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span></a>';
					if(!(document.querySelectorAll('.js-fileslist-json_download').length == 0)) {
						_tag = '';
						_btn = '<span class="di_none js-bookmark-category">3</span><a href="'+val.rt_cf_d_href.href+'" class="__button __red mt20 js-sessionstrage-url js-bookmark-url"><span>詳細ページへ<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span></a>';
					} else if(!(document.querySelectorAll('.js-fileslist-json_research').length == 0)) {
						val.cf_d_tags.forEach(function(tagval, tagindex){
							if(tagval.cf_dt_group_code === 'subject') {
								_tag += '<span class="__label mt20 mr5">'+tagval.cf_dt_name_d+'</span>';
							}
						});
					} else {
						val.cf_d_tags.forEach(function(tagval, tagindex){
							if(tagval.cf_dt_group_code === 'recruitment_types') {
								_tag += '<span class="__label mt20 mr5">'+tagval.cf_dt_name_d+'</span>';
							}
						});
					}
					HTML += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-20-child is-filter-hidden" data-id="'+val._key+'">'+
					'<div class="files-box03 js-bookmark">'+
					'<a href="'+val.rt_cf_d_href.href+'" class="di_block opacity"><figure class="__figure" data-vanillaMh="figure"><img src="'+val.rt_cf_d_thum_img.src+'" class="width-u-100 js-bookmark-img" alt="'+val.cf_d_title+'"></figure></a>'+
					'<div class="__wrap">'+
					_tag+
					'<div class="mod-bookmarkWrap mt10">'+
					_bookmarkBtn+
					'<div class="mod-bookmark-content">'+
					'<h3 class="fs_18 fs_md_16 __head js-bookmark-title" data-vanillaMh="title">'+val.cf_d_title.replace(/\n/g, '<br>')+'</h3>'+
					'</div>'+
					'</div>'+
					'<p class="mt10 __lead" style="white-space: pre-wrap;" data-vanillaMh="lead">'+val.cf_d_sub_title+'</p>'+
					_btn+
					'</div>'+
					'</div>'+
					'</li>';
				 });
				 document.querySelector('.js-fileslist-json').insertAdjacentHTML('afterbegin', HTML);
			};
			// urlパラメータ取得・チェックボックスチェック---------------------
			const paraCheck = () => {
				// URLパラメータ取得
				const searchParams = new URLSearchParams(window.location.search);
				for(const [key, val] of searchParams) {
					// チェックボックスチェック
					navInput.forEach(elem => {
						if((key == elem.getAttribute('name')) && (val.replaceAll("+"," ") == elem.value)) {
							elem.classList.add(a);
							document.querySelector('.files-toggle .js-toggle').classList.add(a);
							document.querySelector('.files-toggle .js-toggleBlock').style.display = 'block';
						}
					});
					// キーワード入力チェック
					serchInput.forEach(elem => {
						if(key == elem.getAttribute('name')) {
							if(elem.value) {
								elem.value = decodeURIComponent(val).replaceAll("+"," ");
							}
						}
					});
				}
			};
			// フィルタリング関数---------------------
			// キーワード・絞り込みボタンフィルタリング
			const filterList = (data) => {
				// console.log(data,'data');
				const _filterList = data;
				// 絞り込みボタンに対するフィルタリングされたデータ
				const filteredData = {
					recruitment_types: [],
					flow: [],
					type: [],
					subject: [],
					keyword: [],
					career_materials: [],
				};
				const filterdKeyword = {
					search_keyword: [],
				}
				Object.keys(filteredData).forEach((_itemcategory) => {
					const checkedValueListArray = (_code) => {
						let _array = [];
						document.querySelectorAll(`[name=${_code}]`).forEach((item, index) => {
							if(item.classList.contains('is-active')) {
								_array.push(item);
							}
						});
						return _array;
					};
					// checkedValueListはチェックされたvalue
					const checkedValueList = Array.from(
						checkedValueListArray(_itemcategory)
					).map((checked) => checked.value);
					// console.log(checkedValueList,'checkedValueList');
					_filterList.forEach((item, index) => {
						if((_itemcategory === 'recruitment_types') || (_itemcategory === 'flow') || (_itemcategory === 'type') || (_itemcategory === 'subject') || (_itemcategory === 'keyword') || (_itemcategory === 'career_materials')) {
							if(item.cf_d_tags) {
								const foundItem = item.cf_d_tags.find(
									(tag) => tag.cf_dt_group_code == _itemcategory
								);
								// _itemcategoryのチェックがあった場合
								if(checkedValueList.length > 0) {
									// チェックされたnameとcf_dt_group_codeが一致した場合
									// console.log(foundItem,'foundItem');
									if(foundItem) {
										const isExists = item.cf_d_tags.filter(
											(tag) => checkedValueList.includes(tag._key)
									 	);
										// const isExists = checkedValueList.includes(foundItem._key);
										// console.log(isExists,'isExists');
										// チェックされたvalueと_keyが一致した場合
										if(isExists.length > 0) {
											filteredData[_itemcategory].push(index);
										}
									}
								} else {
									filteredData[_itemcategory].push(index);
								}
							}
						}
					});
				});
				Object.keys(filterdKeyword).forEach((search_keyword) => {
					const searchObj = document.querySelector(
						`[name=${search_keyword}]`
					);
					const joinedData = _filterList.map((item, index) => {
						const cf_d_title = _.get(item, "cf_d_title");
						const cf_d_sub_title = _.get(item, "cf_d_sub_title");
						const cf_d_remarks = _.get(item, "cf_d_remarks");
						const _key = _.get(item, "_key");
						const concatStr = `${cf_d_title || ""} ${cf_d_sub_title || ""} ${cf_d_remarks || ""} ${_key || ""}`;
						return concatStr;
					});
					joinedData.forEach((item, index) => {
						if(!searchObj || (searchObj && !searchObj.value)) {
							filterdKeyword[search_keyword].push(index);
						} else {
							item.indexOf(searchObj.value) !== -1 && filterdKeyword[search_keyword].push(index);
						}
					});
				});
				// console.log(filteredData,'filteredData');
				// console.log(filterdKeyword,'filterdKeyword');
				const selectedItemIndexList = _.intersection(
					..._.values(filteredData),
					..._.values(filterdKeyword),
				);
				// console.log(selectedItemIndexList,'selectedItemIndexList');
				const resultItemList = selectedItemIndexList.map(
					(index) => _filterList[index]
				);
				return resultItemList;
			};
			// フィルタリング---------------------
			const listFilter = (_data) => {
				// loading表示
				loaderArea.classList.remove('di_none');
				// 0件メッセージ非表示
				document.querySelector('.js-fileslist-json-nomessage').classList.add('di_none');
				// liリスト初期化
				document.querySelectorAll('.js-fileslist-json > li').forEach(function(elem){
					elem.classList.remove(h);
					elem.classList.remove(a);
					elem.classList.add(filterHidden);
				});
				// チェックされた要素のパラメータ追加
				const urlSearchParams = new URLSearchParams('');
				document.querySelectorAll('.js-fileslist-json-nav-button.is-active').forEach(elem => {
					// console.log(elem.getAttribute('name'), elem.value,'inputchecked');
					urlSearchParams.append(elem.getAttribute('name'), elem.value);
				});
				// 入力されたキーワードパラメータ追加
				serchInput.forEach(elem => {
					// console.log(elem.getAttribute('name'), elem.value,'inputchecked');
					if(elem.value) {
						urlSearchParams.append(elem.getAttribute('name'), elem.value);
					}
				});
				if(urlSearchParams.toString()) {
					history.replaceState("", "", `?${urlSearchParams.toString()}`);
				}
				// フィルタリング
				let filterListArray = '';
				if(!(document.querySelectorAll('.js-fileslist-json_download').length == 0)) {
					filterListArray = filterList(_data.rt_bn_service_career_doc_list);
				} else if(!(document.querySelectorAll('.js-fileslist-json_research').length == 0)) {
					filterListArray = filterList(_data.rt_bn_survey_data_doc_list);
				} else {
					filterListArray = filterList(_data.rt_bn_useful_materials_doc_list);
				}
				// console.log(filterListArray,'filterListArray');
				filterListArray.forEach(function(elem,index) {
					document.querySelectorAll('.js-fileslist-json > li').forEach(function(lielem) {
						if(lielem.getAttribute('data-id') == filterListArray[index]._key) {
							lielem.classList.remove(filterHidden);
							lielem.classList.add(h);
						}
					});
				});
				// 初期表示最大18件
				document.querySelectorAll('.js-fileslist-json .is-hidden').forEach(function(elem, index){
					if(index < 18) {
						elem.classList.add(a);
						elem.classList.remove(h);
					}
				});
				// morebtn表示・表示
				moreBtn[0].classList.add('di_none');
				if(document.querySelectorAll('.js-fileslist-json .is-hidden').length) {
					moreBtn[0].classList.remove('di_none');
				}
				if(filterListArray.length) {
					// matchheight
					setTimeout(function(){
						// vanillaMatchHeight();
						$('.is-active .files-box03 .__figure').matchHeight();
						$('.is-active .files-box03 .__head').matchHeight();
						$('.is-active .files-box03 .__lead').matchHeight();
					}, 1000);
				} else {
					// 0件メッセージ表示
					document.querySelector('.js-fileslist-json-nomessage').classList.remove('di_none');
				}
				// loading非表示
				loaderArea.classList.add('di_none');
			};
			// json出力・イベント---------------------
			fetch(getJSONfiles()).then(function (data) {
				return data.json();
			}).then(function (data) {
				  // urlパラメータチェック・チェックボックスチェック
				paraCheck();
				if(!(document.querySelectorAll('.js-fileslist-json_download').length == 0)) {
					addHTML(data.rt_bn_service_career_doc_list);
				} else if(!(document.querySelectorAll('.js-fileslist-json_research').length == 0)) {
					addHTML(data.rt_bn_survey_data_doc_list);
				} else {
					addHTML(data.rt_bn_useful_materials_doc_list);
				}
				// フィルタリング
				listFilter(data);
				serchBtn.forEach(elem => {
					elem.addEventListener('click', e => {
						listFilter(data);
					});
				});
				serchInput.forEach(elem => {
					elem.addEventListener('keydown', (e) => {
						if( e.keyCode === 13 ){
							listFilter(data);
							return false;
						}
					});
				});
				navInput.forEach(elem => {
					elem.addEventListener('click', e => {
						e.currentTarget.classList.toggle(a);
						listFilter(data);
					});
				});
				moreBtn.forEach(elem => {
					elem.addEventListener('click', e => {
						document.querySelectorAll('.js-fileslist-json .is-hidden').forEach(function(lielem, liindex){
							if(liindex < 9) {
								lielem.classList.add(a);
							}
						});
						document.querySelectorAll('.js-fileslist-json .is-active').forEach(function(lielem){
							lielem.classList.remove(h);
						});
						if(!(document.querySelectorAll('.js-fileslist-json .is-hidden').length)) {
							moreBtn[0].classList.add('di_none');
						}
						// matchheight
						setTimeout(function(){
							// vanillaMatchHeight();
							$('.files-box03 .__figure').matchHeight();
							$('.files-box03 .__head').matchHeight();
							$('.files-box03 .__lead').matchHeight();
						}, 500);
					});
				});
				// セッションストレージで一覧へ戻るボタンのパラメータ設定
				document.querySelectorAll('.js-sessionstrage-url').forEach(elem => {
					elem.addEventListener('click', e => {
						sessionStorage.setItem('detailparm',location.search);
					});
				});
				// ④チェックAPI
				let baseURL = '';
				let _passURL = '/mypage/bookmark/chk/';
				if(document.domain === 'review.cmsod.jp') {
					baseURL = 'https://staging.api.saponet.mynavi.jp';
				}
				$.ajax({
					method: 'get',
					url: baseURL + _passURL
				}).then(function (response) {
					console.log(response,'④チェックAPIresponse');
					if(response.list.length) {
						response.list.forEach((listitem, listindex) => {
							$('.js-bookmark-btn').each(function(index, element) {
								if($(element).parents('.js-bookmark').find('.js-bookmark-url').attr('href') == listitem) {
									$(element).addClass(a);
								}
							});
						});
					}
				}).catch(function (err) {
					console.log(err,'err');
				})
			});
		}
	};
	const filesDetail = () => {
		// セッションストレージで一覧へ戻るボタンのパラメータセット
		if(document.querySelectorAll('.js-sessionstrage-url-set').length) {
			let setHref = document.querySelector('.js-sessionstrage-url-set').getAttribute('href') + sessionStorage.getItem('detailparm');
			// console.log(setHref,'setHref');
			if(sessionStorage.getItem('detailparm')) {
				document.querySelector('.js-sessionstrage-url-set').setAttribute('href',setHref);
			}
		} else {
			sessionStorage.removeItem('detailparm');
		}
		// あわせて読みたい記事
		if(document.querySelectorAll('.js-filesDetail-column-json').length) {
			// json定義---------------------
			const getJSONcolumn = (_id) => {
				return `/ajax/column/data/${_id}.json`;
			};
			// json出力・イベント---------------------
			if(document.querySelectorAll('.js-filesDetail-column-jsonWrap .rt_cf_d_column_key').length) {
				let itemArray = [];
				let count = 0;
				new Promise((resolve) => {
					document.querySelectorAll('.js-filesDetail-column-jsonWrap .rt_cf_d_column_key').forEach((elem, index) => {
						// console.log(elem.textContent,'elem.textContent');
						fetch(getJSONcolumn(elem.textContent)).then(function (data) {
							return data.json();
						}).then(function (datajson) {
							count += 1;
							// console.log(datajson.rt_bn_news_info[0], count, index);
							itemArray.push({ html: datajson.rt_bn_news_info[0], idx: index });
							if((count) == document.querySelectorAll('.js-filesDetail-column-jsonWrap .rt_cf_d_column_key').length) {
								// console.log('return');
								return resolve(itemArray);
							}
						});
					});
				}).then(() => {
					// 昇順ソート
					itemArray.sort((a, b) => a.idx - b.idx);
					// console.log(itemArray,'itemArray2');
					// console.log(itemArray.length,'itemArraylen');
					let HTML = '';
					itemArray.forEach((item, index) => {
						// console.log(item.html,'item');
						if(index < 3) {
							HTML += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-20-child">'+
							'<a href="'+item.html.rt_cf_n_href_column.href+'" class="di_block opacity">'+
							'<div class="files-box03" data-vanillaMh="columnbox">'+
							'<figure class="__figure" data-vanillaMh="columnfigure"><img src="'+item.html.rt_cf_n_thum_img.src+'" class="width-u-100" alt="'+item.html.cf_n_title+'" /></figure>'+
							'<div class="__wrap" data-vanillaMh="columnlead">'+
							'<p class="__dayWrap mt20">'+
							'<span class="__label">'+item.html.rt_cf_n_category_name.content+'</span>'+
							'<span class="__day">'+item.html.rt_cf_n_date.content+'</span>'+
							'</p>'+
							'<p class="mt10 fw_bold td_under __lead" style="white-space: pre-wrap;">'+item.html.cf_n_title.replace(/\n/g, '<br>')+'</p>'+
							'</div>'+
							'</div>'+
							'</a>'+
							'</li>';
						}
					});
					document.querySelector('.js-filesDetail-column-json').insertAdjacentHTML('afterbegin', HTML);
					if(document.querySelectorAll('.js-filesDetail-downloadWrap').length) {
						document.querySelector('.js-filesDetail-downloadWrap').classList.remove('di_none');
					}
					// matchheight
					setTimeout(function(){
						// vanillaMatchHeight();
							$('.files-box03 .__figure').matchHeight();
							$('.files-box03 .__lead').matchHeight();
					}, 500);
				});
			} else {
				document.querySelector('.js-filesDetail-column-jsonWrap').classList.add('di_none');
			}
		}
		// 関連資料
		if(document.querySelectorAll('.js-filesDetail-relation-json').length) {
			let pageid = '';
			if(!(document.querySelectorAll('.js-filesDetail-relation-json_download').length == 0)) {
				pageid = location.pathname.split('/')[4].replace('.html','');
			} else if(!(document.querySelectorAll('.js-filesDetail-relation-json_research').length == 0)) {
				pageid = location.pathname.split('/')[3].replace('.html','');
			} else {
				pageid = location.pathname.split('/')[3].replace('.html','');
			}
			// json定義---------------------
			const getJSONrelation = () => {
				if(!(document.querySelectorAll('.js-filesDetail-relation-json_download').length == 0)) {
					return `/ajax/doc/service_career_doc.json`;
				} else if(!(document.querySelectorAll('.js-filesDetail-relation-json_research').length == 0)) {
					return `/ajax/doc/survey_data_doc.json`;
				} else {
					return `/ajax/doc/useful_materials_doc.json`;
				}
			};
			// json出力・イベント---------------------
			if(document.querySelectorAll('.js-filesDetail-relation-jsonWrap .cf_d_tags > span').length) {
				fetch(getJSONrelation()).then(function (data) {
					return data.json();
				}).then(function (data) {
					let dataLint = '';
					if(!(document.querySelectorAll('.js-filesDetail-relation-json_download').length == 0)) {
						dataLint = data.rt_bn_service_career_doc_list;
					} else if(!(document.querySelectorAll('.js-filesDetail-relation-json_research').length == 0)) {
						dataLint = data.rt_bn_survey_data_doc_list;
					} else {
						dataLint = data.rt_bn_useful_materials_doc_list;
					}
					let _array = [];
					dataLint.forEach(dataelem => {
						if(!(dataelem._key == pageid)) {
							document.querySelectorAll('.js-filesDetail-relation-jsonWrap .cf_d_tags > span').forEach(lielem => {
								const foundItem = dataelem.cf_d_tags.find(
									(tag) => tag._key == lielem.textContent
								);
								if(foundItem) {
									_array.push(dataelem);
								}
							});
						}
					});
					// console.log(_array,'_array');
					const result = _array.filter((e, index, self) => {
						return self.findIndex((el) => el._key === e._key) === index;
					});
					// console.log(result,'result');
					if(result.length) {
						let HTML = '';
						for(let l=0; l < 3; l++) {
							// console.log(l,result[l]);
							if(result[l]) {
								// タグ部分
								let _tag = '';
								let _btn = '<p class="__button mt20"><span>詳細ページへ<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span></p>';
								if(!(document.querySelectorAll('.js-filesDetail-relation-json_download').length == 0)) {
									_tag = '<div class="mt20"></div>';
									_btn = '<p class="__button __red mt20"><span>詳細ページへ<svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span></p>';
								} else if(!(document.querySelectorAll('.js-filesDetail-relation-json_research').length == 0)) {
									result[l].cf_d_tags.forEach(function(tagval, tagindex){
										if(tagval.cf_dt_group_code === 'subject') {
											_tag += '<span class="__label mt20 mr5">'+tagval.cf_dt_name_d+'</span>';
										}
									});
								} else {
									result[l].cf_d_tags.forEach(function(tagval, tagindex){
										if(tagval.cf_dt_group_code === 'recruitment_types') {
											_tag += '<span class="__label mt20 mr5">'+tagval.cf_dt_name_d+'</span>';
										}
									});
								}
								HTML += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-20-child is-filter-hidden" data-id="'+result[l]._key+'">'+
								'<a href="'+result[l].rt_cf_d_href.href+'" class="di_block opacity">'+
								'<div class="files-box03">'+
								'<div class="__wrap">'+
								_tag+
								'<h3 class="fs_18 fs_md_16 mt5 __head">'+result[l].cf_d_title.replace(/\n/g, '<br>')+'</h3>'+
								'<p class="mt10 __lead" style="white-space: pre-wrap;">'+result[l].cf_d_sub_title+'</p>'+
								_btn+
								'</div>'+
								'</div>'+
								'</a>'+
								'</li>';
							}
						}
						document.querySelector('.js-filesDetail-relation-json').insertAdjacentHTML('afterbegin', HTML);
						if(document.querySelectorAll('.js-filesDetail-downloadWrap').length) {
							document.querySelector('.js-filesDetail-downloadWrap').classList.remove('di_none');
						}
						setTimeout(function(){
							// vanillaMatchHeight();
							$('.files-box03 .__head').matchHeight();
							$('.files-box03 .__lead').matchHeight();
						}, 500);
					} else {
						document.querySelector('.js-filesDetail-relation-jsonWrap').classList.add('di_none');
					}
				});
			} else {
				document.querySelector('.js-filesDetail-relation-jsonWrap').classList.add('di_none');
			}
		}
		// バックナンバー
		if(document.querySelectorAll('.js-filesDetail-backnumber-json').length) {
			let tagid = document.querySelector('.js-filesDetail-backnumber-jsonWrap .cf_d_tags span').textContent;
			let detailid = document.querySelector('.js-filesDetail-backnumber-jsonWrap .rt_cf_d_id').textContent;
			// json定義---------------------
			const getJSONbacknumber = () => {
				return `/ajax/doc/survey_data_doc_back/${tagid}/${detailid}.json`;
			};
			// json出力・イベント---------------------
			fetch(getJSONbacknumber()).then(function (data) {
				return data.json();
			}).then(function (data) {
				// console.log(data,'data');
				if(data.rt_bn_survey_data_doc_list.length) {
					let _array = [];
					data.rt_bn_survey_data_doc_list.forEach((item, index) => {
						let _year = '';
						let _yearorder = '';
						item.cf_d_tags.forEach(yearitem => {
							if(yearitem.cf_dt_group_code == 'year') {
								_year = yearitem.cf_dt_name_d;
								_yearorder = yearitem.cf_dt_order;
							}
						});
						_array.push({ 
							date: item.cf_d_date,
							datetime: item.rt_cf_d_date.datetime,
							href: item.rt_cf_d_href.href,
							year: _year,
							yearorder: _yearorder,
						});
					});
					// console.log(_array,'_array');
					// ソート
					_array.sort((a, b) => {
						//yearorderの降順
						if(a.yearorder > b.yearorder) return -1;
						if(a.yearorder < b.yearorder) return 1;
						//dateの昇順
						if(a.date > b.date) return 1;
						if(a.date < b.date) return -1;
						return 0;
					});
					let HTML = '';
					let _head = '';
					_array.forEach((item, index) => {
						if(!(_head == item.year)) {
							if(!(_head == '')) {
								HTML += '</ul></li>';
							}
							HTML += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-20-child">'+
							'<p class="fw_bold">'+item.year+'</p>'+
							'<ul class="ul-disc color_main mt10">';
							_head = item.year;
						}
						HTML += '<li><a href="'+item.href+'" class="mod-link03 opacity color_main">'+item.datetime.split('-')[0]+'年'+Number(item.datetime.split('-')[1])+'月'+Number(item.datetime.split('-')[2])+'日'+'</a></li>';
						if(_array.length == (index + 1)) {
							HTML += '</ul></li>';
						}
					});
					document.querySelector('.js-filesDetail-backnumber-json').insertAdjacentHTML('afterbegin', HTML);
					document.querySelector('.js-filesDetail-backnumber-jsonWrap').classList.remove('di_none');
					if(document.querySelectorAll('.js-filesDetail-downloadWrap').length) {
						document.querySelector('.js-filesDetail-downloadWrap').classList.remove('di_none');
					}
				}
			});
		}
	};
	filesList();
	filesDetail();
})(window.jQuery, window.FUNCTIONS);